module.exports = __webpack_public_path__ + "img/incomeBg-dark_73d09.png";